import { renderTextLineClamp } from 'helpers';
import { OperationsListItem } from 'modules/operation/operations/types';

export const renderClient = (item: OperationsListItem) =>
  renderTextLineClamp(item.clientName);
